export enum SubAccountStatus {
  PENDING = 'ACCOUNT_STATUS_PENDING',
  APPROVED = 'ACCOUNT_STATUS_APPROVED',
  REJECTED = 'ACCOUNT_STATUS_REJECTED',
}

export enum SubAccountPurpose {
  TRADING = 'PURPOSE_TRADING',
  LONG_TERM_INVESTING = 'PURPOSE_LONG_TERM_INVESTING',
  SHORT_TERM_INVESTING = 'PURPOSE_SHORT_TERM_INVESTING',
}

export enum CanotCreateReason {
  INSUFFICIENT = 'REASON_TYPE_INSUFFICIENT_EQUITY_AMOUNT',
  MAX_REACHED = 'REASON_TYPE_MAX_SUB_ACCOUNT_REACHED',
}

export interface iSubAccount {
  account_number: string;
  account_status: SubAccountStatus;
  is_main_account: boolean;
  portfolio_info: {
    portfolio_name: string;
    purpose: SubAccountPurpose;
  };
}

interface CanotCreateSubAccount {
  type: CanotCreateReason;
  title: string;
  description: string;
}

export interface GetSubAccountResponse {
  sub_accounts: iSubAccount[];
  can_create_new_sub_account: boolean;
  can_not_create_new_sub_account_reason: CanotCreateSubAccount;
}

export interface iPurpose {
  type: SubAccountPurpose;
  text: string;
}

export interface GetPurposeResponse {
  purposes: iPurpose[];
}

interface TNC {
  feature_id: string;
  version: number;
}

export interface CreateAccountPayload {
  portfolio_name: string;
  tnc: TNC;
  purpose: string;
  idempotency_ref?: string;
}

export interface CreateRenameResponse {
  sub_accounts: iSubAccount[];
}

export interface RenameAccountPayload {
  target_account_number: string;
  new_portfolio_name: string;
  idempotency_ref?: string;
}

export interface MoveCashPayload {
  from_acc_no: string;
  from_acc_name?: string;
  to_acc_no: string;
  to_acc_name?: string;
  amount: number;
}

export interface iStocks {
  stock_code: string;
  shares: number;
  avatar_url?: string;
}

export interface MoveStockPayload {
  from_acc_no: string;
  from_acc_name?: string;
  to_acc_no: string;
  to_acc_name?: string;
  stocks_data: iStocks[];
}

export interface GetWithwdrawablePayload {
  balance_scope?: string;
  account_number?: string;
}

interface WithdrawalBalance {
  withdrawable: number;
  transaction: number;
  pending: number;
  leverage_liability: number;
  net_withdrawable: number;
}

interface Settlement {
  title: string;
  formatted_date: string;
  balance: number;
}

export interface GetWithdrawableResponse {
  balance: WithdrawalBalance | null;
  settlement_schedules: Settlement[];
  legends: string[];
}

export interface iTransferableStockItem {
  stock_code: string;
  transferable_shares_qty: string;
  stock_icon_url: string;
}

export interface GetTransferableStockResponse {
  stocks: iTransferableStockItem[];
}

interface AggregatedPortfolioSummary {
  trading: {
    balance: number;
  };
  amount: {
    invested: number;
    allocated: number;
    credit_limit: number;
  };
  profit_loss: {
    net: number;
    unrealised: number;
    realised: number;
  };
  gain: number;
  equity: number;
  debt: {
    ratio: number;
    total: number;
    market_value: number;
  };
}

interface PortfolioSummary {
  account_number: string;
  portfolio_name: string;
  summary: AggregatedPortfolioSummary;
}

export interface GetTradingBalanceResponse {
  aggregated_portfolio_summary: AggregatedPortfolioSummary;
  summary_per_portfolios: PortfolioSummary[];
}

export interface iTradingBalance {
  balance: number;
  equity: number;
}
